// extracted by mini-css-extract-plugin
export default {"header":"header--Ewuy7xmY"};